import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于海角论坛 - 品牌介绍与联系方式',
    description: '海角论坛是深受用户喜爱的综合性交流社区平台，覆盖技术交流、生活分享、数码产品、游戏娱乐等八大核心板块，服务超过128万注册会员。',
    url: 'https://haijiao.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '海角论坛',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="container-custom py-5">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section className="bg-background-100 border-b border-background-200/70">
          <div className="container-custom py-10">
            <div className="text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">
                关于海角论坛
              </h1>
              <p className="mt-3 text-foreground-600 max-w-2xl mx-auto">
                了解海角论坛的品牌故事、发展历程与核心价值，感受我们为用户打造优质社区交流平台的初心与坚持
              </p>
            </div>
          </div>
        </section>

        <BrandIntro />
        <Reputation />
        <ContactSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}